import { createReducer } from '@reduxjs/toolkit'
import { retrieveCcamCategoryLabels } from '../../core/use-cases/retrieveCcamCategoryLabels'

type CcamCategoryLabelsState = {
  loading: boolean
  value: string[]
}

const initialState: CcamCategoryLabelsState = {
  loading: false,
  value: [],
}

export const ccamCategorylabelsReducer = createReducer(
  initialState,
  builder => {
    builder.addCase(retrieveCcamCategoryLabels.pending, state => {
      state.loading = true
      state.value = []
    })
    builder.addCase(retrieveCcamCategoryLabels.fulfilled, (state, action) => {
      state.loading = false
      state.value = action.payload
    })
  }
)
